import { motion } from "framer-motion";
import { UtensilsCrossed, Cookie, CakeSlice, GraduationCap, Camera } from "lucide-react";

const TABS = [
  { id: "ricette", label: "Ricette", icon: UtensilsCrossed },
  { id: "biscotti", label: "Biscotti e Decorazioni", icon: Cookie },
  { id: "tecniche", label: "Tecniche", icon: CakeSlice },
  { id: "galleria", label: "Le Torte", icon: Camera },
  { id: "corso", label: "Il Corso", icon: GraduationCap },
];

const BottomNav = ({ active, onChange }) => (
  <nav
    data-testid="bottom-nav"
    className="fixed bottom-0 left-0 right-0 z-50 px-3 pb-3"
  >
    <div className="mx-auto flex max-w-md items-stretch justify-between rounded-3xl border border-pink-100 bg-white/90 px-2 py-2 shadow-[0_12px_40px_rgba(45,36,36,0.14)] backdrop-blur-xl lg:max-w-lg">
      {TABS.map(({ id, label, icon: Icon }) => {
        const isActive = active === id;
        return (
          <button
            key={id}
            data-testid={`nav-tab-${id}`}
            onClick={() => onChange(id)}
            className="relative flex flex-1 flex-col items-center gap-1 rounded-2xl px-1 py-2"
          >
            {isActive && (
              <motion.span
                layoutId="nav-pill"
                className="absolute inset-0 rounded-2xl bg-blush"
                transition={{ type: "spring", stiffness: 400, damping: 32 }}
              />
            )}
            <Icon
              className={`relative h-5 w-5 transition-colors ${isActive ? "text-rosa-dark" : "text-cacao-light"}`}
              strokeWidth={isActive ? 2.4 : 2}
            />
            <span
              className={`relative text-[10px] font-semibold leading-tight transition-colors sm:text-[11px] ${
                isActive ? "text-rosa-dark" : "text-cacao-light"
              }`}
            >
              {label}
            </span>
          </button>
        );
      })}
    </div>
  </nav>
);

export default BottomNav;
